import React from 'react';
import ReactLoading from 'react-loading';
import colors from '../util/colors';

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * `components/Loading` cannot be used for this. It is driven by redux
 * (`state.ux.loading`) and returns `null` when that flag is false — which is exactly the
 * case while a route chunk is in flight, since nothing has dispatched `showLoading()`.
 * Using it as a Suspense fallback renders a blank page during the fetch.
 *
 * This one always renders, and deliberately reuses the same spinner (`cubes`) and brand
 * colour so a route transition looks identical to the app's existing loading state.
 *
 * Not fixed-position and no backdrop, unlike `Loading`: this replaces page content that
 * has not arrived yet rather than overlaying content that already exists.
 */
function RouteFallback() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '60vh'
      }}>
      <ReactLoading type="cubes" color={colors.YELLOW} height={100} width={100} />
    </div>
  );
}

export default React.memo(RouteFallback);
